<table
  mat-table
  [dataSource]="result"
  multiTemplateDataRows
  class="mat-elevation-z8"
>
  <ng-container matColumnDef="sourceId">
    <th mat-header-cell class="header" *matHeaderCellDef>SourceId</th>
    <td mat-cell *matCellDef="let element">
      {{ element.sourceId }}
    </td>
  </ng-container>

  <ng-container matColumnDef="name">
    <th mat-header-cell class="header" *matHeaderCellDef>Nome</th>
    <td mat-cell *matCellDef="let element">
      {{ element.name }}
    </td>
  </ng-container>

  <ng-container matColumnDef="document">
    <th mat-header-cell class="header" *matHeaderCellDef>CNPJ</th>
    <td mat-cell *matCellDef="let element">
      {{ element.document }}
    </td>
  </ng-container>

  <ng-container matColumnDef="actions" sticky>
    <th mat-header-cell class="header" *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element" class="actions"></td>
  </ng-container>

  <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
  <ng-container matColumnDef="expandedDetail">
    <td mat-cell *matCellDef="let element" [attr.colspan]="ColumnsQuota.length">
      <div
        class="example-element-detail"
        [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'"
      >
        <div class="example-element-description">
          <div class="title-description">
            <h5>Erros encontrados:</h5>
          </div>
          <ul *ngFor="let error of element.errors">
            <li>
              {{ error }}
            </li>
          </ul>
        </div>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="ColumnsQuota"></tr>
  <tr
    mat-row
    *matRowDef="let element; columns: ColumnsQuota"
    class="example-element-row"
    [class.example-expanded-row]="expandedElement === element"
    (click)="expandedElement = expandedElement === element ? null : element"
  ></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: ['expandedDetail']"
    class="example-detail-row"
  ></tr>
</table>
